import React, { useState } from 'react'
import './CustomerTable.css'

const CustomerTable = ({ data, onEdit, onDelete }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredData, setFilteredData] = useState(data)

  React.useEffect(() => {
    if (searchTerm === '') {
      setFilteredData(data)
    } else {
      const filtered = data.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.status.toLowerCase().includes(searchTerm.toLowerCase())
      )
      setFilteredData(filtered)
    }
  }, [searchTerm, data])

  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'joined':
        return 'status-badge status-joined'
      case 'pending':
        return 'status-badge status-pending'
      case 'failed':
        return 'status-badge status-failed'
      default:
        return 'status-badge'
    }
  }

  return (
    <div className="customer-table-container">
      <div className="customer-table-header">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search customers..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      
      <div className="table-wrapper">
        <table className="customer-table">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Role</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">
                  No customers found
                </td>
              </tr>
            ) : (
              filteredData.map((item) => (
                <tr key={item.id || item.name + item.role}>
                  <td>{item.name}</td>
                  <td>
                    <span className="role-badge">{item.role}</span>
                  </td>
                  <td>
                    <span className={getStatusBadgeClass(item.status)}>
                      {item.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn delete-btn"
                        onClick={() => onDelete && onDelete(item)}
                        aria-label="Delete customer"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14zM10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                      <button
                        className="action-btn edit-btn"
                        onClick={() => onEdit && onEdit(item)}
                        aria-label="Edit customer"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CustomerTable

